import React, { useState } from "react";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import { GoEye } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";

export default function LocalFinalExitList({
  titles = [],
  list = [],
  loading,
  updateData,
  setId,
  setPropsData,
  onSearch,
  isLoading = false,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchWords, setSearchWords] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list);

  const editData = (id, data) => {
    console.log("LocalFinalExitList - editData called with id:", id);
    console.log("LocalFinalExitList - editData called with data:", data);
    setId(id);
    setPropsData(data);
    navigate(`/dashboard/settlement-preview/details/`);
  };

  const handleSearchInput = (e) => {
    const value = e.target.value;
    setSearchInput(value);
  };

  const handleSearchClick = () => {
    if (searchInput.trim() !== "") {
      setSearchWords([searchInput]);
      // Call API on button click
      if (onSearch) {
        onSearch(searchInput);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchClick();
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "";
    }

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const formattedDate = `${day}-${monthName.toLowerCase()}-${year}`;

    return formattedDate;
  };

  const token = localStorage.getItem("nodeToken");

  const onDownloadExcel = async () => {
    try {
      const response = await nodeinstance.get("/mobilization/excelDownload", {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Settlement_Preview_summary.xlsx`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);

        dispatch(
          setAppError({
            msg: "Excel downloaded successfully!",
            color: "success",
          })
        );
      } else {
        throw new Error("Failed to download the Excel file.");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message || "An error occurred while downloading the file.",
        })
      );
    }
  };

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex space-x-2 ">
          <div className="gap-2 w-full items-center flex flex-row-reverse">
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => onDownloadExcel()}
            >
              <p>Download</p>
            </button>
            <button
              className="p-2 px-4 rounded-md bg-green-600 hover:bg-green-700 disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={handleSearchClick}
              disabled={!searchInput.trim() || isLoading}
            >
              <p>Search</p>
            </button>
            <input
              type="text"
              placeholder="Search by Employee ID"
              value={searchInput}
              onChange={handleSearchInput}
              onKeyPress={handleKeyPress}
              className="p-2 border border-gray-300 rounded-md w-full max-w-xs text-sm"
            />
          </div>
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-exitformalities auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline rounded-md`}
        >
          {titles.map((t, index) => (
            <p key={index} className="font-semibold uppercase">
              {t}
            </p>
          ))}
          {isLoading && (
            <div className="col-span-full flex justify-center items-center p-10">
              <p className="text-gray-500">Searching...</p>
            </div>
          )}
          {!isLoading && !searchInput && (
            <div className="col-span-full flex justify-center items-center p-10">
              <p className="text-gray-500">Please enter Employee ID to search</p>
            </div>
          )}
          {!isLoading && searchInput && (!currentList || currentList.length === 0) && (
            <div className="col-span-full flex justify-center items-center p-10">
              <p className="text-gray-500">No results found for "{searchInput}"</p>
            </div>
          )}

          {!isLoading && currentList && currentList.length > 0
            ? currentList?.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.point_of_hire || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.candidate_id || "-"}
                    />
                  </p>

                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.name || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.nationality || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.actual_profession || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.visa_profession || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.basic_salary || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={"-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.total_salary?.toString() || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.client || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.visa_provider
                          ? list.visa_provider
                          : list.Overseas_visa_provider
                            ? list.Overseas_visa_provider
                            : "-"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.iqama_number || "-"}
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={
                        list.iqama_expiry_date_g
                          ? formatDate(list.iqama_expiry_date_g)
                          : "-"
                      }
                    />
                  </p>
                  <p>
                    <Highlighter
                      searchWords={searchWords}
                      autoEscape={true}
                      textToHighlight={list.demobilization_type || "-"}
                    />
                  </p>
                  <p>{list.demobilization_comments}</p>

                  <div
                    className="ml-2 cursor-pointer"
                    onClick={() => editData(list.candidate_id, list)}
                  >
                    <GoEye fontSize={22} className="ml-2" />
                  </div>

                  <hr
                    className={`border-[1.5px] border-slate-100 w-full col-span-full`}
                  />
                </React.Fragment>
              ))
            : ""}
        </div>
        <Pagination />
      </div>
    </>
  );
}
